import FuseUtils from '@fuse/utils';
import { Navigate } from 'react-router-dom';

import settingsConfig from 'app/configs/settingsConfig';
import { QuestionnaireListConfig } from 'app/main/questionnaire/QuestionnaireConfig';

import { AMLConfig } from 'app/main/aml/AMLConfig';
import { HomePageConfig } from 'app/main/home-page/HomePageConfig';
import { AuthConfig } from '../main/auth/AuthConfig';
import { UsersConfig, InvitesConfig, RoleManagementConfig } from '../main/teams/TeamsConfig';
import { ClientDetailsConfig } from '../main/client-details/ClientDetailsConfig';
import { ApplicationsConfig } from '../main/applications/ApplicationsConfig';
import { BillingConfig } from '../main/billing/BillingConfig';
import { PaymentPagesConfig } from '../main/billing/PaymentPagesConfig';
import { DashboardConfig } from '../main/dashboard/DashboardConfig';
import { NoPermissionsPageConfig } from '../main/no-permissions-page/NoPermissionsConfig';

import { VerificationsConfig } from '../main/verifications/VerificationsConfig';
import { WorkflowsConfig } from '../main/workflow-builder/WorkflowBuilderConfig';
import { UniversalLinksConfig } from '../main/universal-links/UniversalLinksConfig';
import { TransactionMonitoringConfig } from '../main/transaction-monitoring/TransactionMonitoringConfig';

const routeConfigs = [
  HomePageConfig,
  AuthConfig,
  DashboardConfig,
  VerificationsConfig,
  ClientDetailsConfig,
  UsersConfig,
  InvitesConfig,
  RoleManagementConfig,
  ApplicationsConfig,
  BillingConfig,
  PaymentPagesConfig,
  WorkflowsConfig,
  UniversalLinksConfig,
  QuestionnaireListConfig,
  AMLConfig,
  TransactionMonitoringConfig,

  NoPermissionsPageConfig,
];

const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs, settingsConfig.defaultAuth),
  {
    path: '/',
    element: <Navigate to="/dashboard" />,
  },
  {
    path: '*',
    element: <Navigate to="/dashboard" />,
  },
];

export default routes;
